import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetItemListHeader: {
    height: theme.spacing(3),
    alignItems: 'center',
    textTransform: 'capitalize',
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.background.default,
    borderRadius: '10px 10px 0 0',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  trainingSetItemListRow: {
    height: theme.spacing(3),
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),

    '&:last-child': {
      borderRadius: '0 0 10px 10px',
    },
  },
  oddRow: {
    background: theme.palette.exerciseStatus.notStartedOddLine,
  },
  setWrapper: {
    ...theme.mixins.appContainer,
  },
}));
